// extracted by mini-css-extract-plugin
export var container = "_56-0";
export var error = "_56-9";
export var label = "_56-5";
export var light = "_56-6";
export var md = "_56-3";
export var sm = "_56-2";
export var thin = "_56-8";
export var thinBold = "_56-7";
export var vertical = "_56-4";
export var xs = "_56-1";